import { IAppDataLoader, IAppInitParams } from "app/model"
import { FORECAST_ORDER_NAME } from "order/model"
import { orderRPO } from "order/repository"
import { createForecastOrder } from "./campaign-forecast"

export const orderDataLoader: IAppDataLoader = async (params: IAppInitParams, onFinish: (error?: string) => any) => {
  try {
    const orders = await orderRPO.getAllOrders()
    const forecastOrder = orders.find(o => o.name === FORECAST_ORDER_NAME)
    if (!forecastOrder) {
      orders.push(await createForecastOrder())
    }
    params.orders = orders
    onFinish()
  } catch (error) {
    console.error(error)
    onFinish(`Orders data-loader error ${String(error)}`)
  }
}
